import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// The heads-up over the first email: MSB already sends an email at that moment, so waiting an
// hour or two keeps the two from arriving together. Only a suggestion: "Not now" dismisses it
const FirstEmailTip = ({ suggestion, onAddDelay, onDismiss }) => {
  const { t } = useTranslation("coaching-portal");
  const tr = (key, params) => t(`emailAutomations.builder.${key}`, params);
  return (
    <aside className="ab-tip">
      <p>
        <strong>{tr("tip.headsUp")}</strong>{" "}
        {tr("fix.suggestion.first_email_delay", {
          email: suggestion.systemEmail?.name,
        })}
      </p>
      <div className="ab-tip__actions">
        <button type="button" data-button-type="primary" onClick={onAddDelay}>
          {tr("tip.addDelay")}
        </button>
        <button type="button" data-button-type="secondary" onClick={onDismiss}>
          {tr("tip.notNow")}
        </button>
      </div>
    </aside>
  );
};

FirstEmailTip.propTypes = {
  suggestion: PropTypes.object.isRequired,
  onAddDelay: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default FirstEmailTip;
